<template>
  <v-container>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" width="609" @click:outside="closeModal" :retain-focus="false">
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                {{ $t('goals.chooseGoalSubject') }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-form ref="addUser" lazy-validation autocomplete="off">
              <v-card-text class="black--text">
                <v-row v-for="(item, index) in goalSubjectForm" :key="index">
                  <v-col cols="12">
                    {{ $t('goals.goalSubjectMandatory') }}<span class="red--text">*</span>
                    <v-select item-text="subject" item-value="id" :items="goalSubjects" v-model="item.goalSubjectId"
                      outlined dense hide-details placeholder="Set goal for?" @change="resetGoalSubjectForm(index)"
                      required></v-select>
                  </v-col>
                  <v-col cols="12" v-if="item.goalSubjectId === 1">
                    {{ $t('goals.animalTypeMandatory') }} <span class="red--text">*</span>
                    <v-select item-text="animal_type" item-value="id" :items="animalTypes"
                      v-model.number="item.animalType" outlined dense hide-details :placeholder="$t('goals.chooseAnimalType')"
                      required></v-select>
                  </v-col>
                  <v-col cols="12" v-if="item.goalSubjectId === 3">
                    {{ $t('goals.animalBreedMandatory') }} <span class="red--text">*</span>
                    <v-select item-text="animal_breed" item-value="id" :items="animalBreeds"
                      v-model.number="item.animalBreed" outlined dense hide-details
                      :placeholder="$t('goals.chooseAnimalBreed')" required></v-select>
                  </v-col>
                  <v-col cols="12" v-if="item.goalSubjectId === 2">
                    {{ $t('goals.animalCategoryMandatory') }} <span class="red--text">*</span>
                    <v-select item-text="name" item-value="id" :items="animalCategories" v-model="item.animalCategory"
                      outlined dense hide-details :placeholder="$t('goals.chooseAnimalCategory')" required></v-select>
                  </v-col>
                  <v-col cols="12" v-if="item.goalSubjectId === 4">
                    {{ $t('goals.animalGroupMandatory') }} <span class="red--text">*</span>
                    <v-select item-text="name" item-value="id" :items="animalGroups" v-model.number="item.animalGroup"
                      outlined dense hide-details :placeholder="$t('goals.chooseAnimalGroup')" required></v-select>
                  </v-col>
                  <v-col cols="12" class="text-right" v-if="index >= 0">
                    <v-btn depressed class="red--text" @click="removeGoalSubject(index)">
                      {{ $t('remove') }}
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-btn depressed style="background: #E5F8F1; color: #00BD73;height: 54px; text-transform: none;"
                      @click="addGoalSubject">
                      {{ $t('goals.anotherGoalSubject') }}
                      <img src="/img/Group 7148.svg" />
                    </v-btn>
                  </v-col>
                </v-row>

                <v-divider class="mt-5"></v-divider>
                <v-card-actions class="mt-10" style="padding-right: 0">
                  <v-spacer></v-spacer>
                  <v-btn outlined class="mr-2" right height="44" width="116" depressed color="primary"
                    @click="closeModal">
                    {{ $t("cancel") }}
                  </v-btn>

                  <v-btn right height="44" width="116" color="primary" @click="saveGoalSubjects"
                    :disabled="saveValidation">
                    {{ $t("save") }}
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-container>
</template>
<script>
import gql from 'graphql-tag'
export default {
  data() {
    return {
      goalSubjectForm: [{
        goalSubjectId: null,
        animalType: null,
        animalBreed: null,
        animalCategory: null,
        animalGroup: null
      }],
      goalSubjects: [],
      animalTypes: [],
      animalBreeds: [],
      animalGroups: [],
      animalCategories: []
    };
  },
  computed: {
    dialog() {
      return this.dialogI;
    },

    saveValidation() {
      let isDisabled = false;
      this.goalSubjectForm.forEach(item => {
        if (!item['goalSubjectId'] || (!item.animalBreed && !item.animalCategory && !item.animalGroup && !item.animalType)) {
          isDisabled = true;
          return;
        }
      });
      return isDisabled;
    }
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
    goalSubjectsProp: {
      type: Array,
      required: false
    }
  },
  created() {
    if (this.goalSubjectsProp && this.goalSubjectsProp.length > 0) {
      this.goalSubjectForm = this.goalSubjectsProp
    }
  },
  methods: {
    closeModal() {
      this.$emit("closeChooseSubject");
      this.resetGoalSubjectForm('all')
    },
    saveGoalSubjects() {
      this.$emit('emitGoalSubjects', this.goalSubjectForm)
      this.$emit("closeChooseSubject");
    },
    resetGoalSubjectForm(index) {
      if (index === 'all') {
        this.goalSubjectForm = [{
          goalSubjectId: null,
          animalType: null,
          animalBreed: null,
          animalCategory: null,
          animalGroup: null
        }]
      } else {
        this.goalSubjectForm[index].animalType = null
        this.goalSubjectForm[index].animalBreed = null
        this.goalSubjectForm[index].animalCategory = null
        this.goalSubjectForm[index].animalGroup = null
      }
    },
    addGoalSubject() {
      this.goalSubjectForm.push({
        goalSubjectId: null,
        animalType: null,
        animalBreed: null,
        animalCategory: null,
        animalGroup: null
      })
    },
    removeGoalSubject(index) {
      this.goalSubjectForm = this.goalSubjectForm.filter((item, idx) => idx !== index)
    }
  },
  apollo: {
    goalSubjects: gql`query {
      goalSubjects {
        id,
        subject
      }
    }`,
    animalTypes: gql`query {
      animalTypes {
        id,
        animal_type
      }
    }`,
    animalBreeds: gql`query {
      animalBreeds {
        id,
        animal_breed
      }
    }`,
    animalGroups: gql`query {
      animalGroups {
        id,
        name
      }
    }`,
    animalCategories: {
      query() {
        return gql`query {
          animalCategories {
            id,
            name
          }
        }`
      },
      update: data => data.animalCategories.map(item => ({
        ...item,
        id: parseInt(item.id)
      }))
    }
  }
};
</script>

<style>

</style>
